module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "UserViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.workflowGroup.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.workflowNamesByKeys(_vm.workflowGroup.workflow_keys)))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.org['curOrg']['role'] == '1' || _vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn btn-danger form-group rightey",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#deleteWorkflowGroup"
    }
  }, [_vm._v("Delete Group")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "UserEditing col-md-5"
  }, [_c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.workflowGroupEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.workflowGroupEdit, "name", $$v)
      },
      expression: "workflowGroupEdit.name"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "Workfow(s)",
      "multiple": "",
      "options": _vm.workflows,
      "validation": "required",
      "value": _vm.write_workflows,
      "items": _vm.write_workflows,
      "label": "name",
      "name": "workflows"
    },
    on: {
      "update:value": function($event) {
        _vm.write_workflows = $event
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1)])])])]), _vm._v(" "), _c('deleteworkflowgroup', {
    attrs: {
      "name": "deleteWorkflowGroup"
    },
    on: {
      "deleteWorkflowGroup": _vm.deleteWorkflowGroup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57356d92","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/WorkflowGroups/WorkflowGroupDetail.vue
// module id = 628
// module chunks = 1